import React from "react";

export const TableReporteEstadistica = ({ data }) => {
  if (data.length > 0) {
    return (
      <tbody>
        {data.map((element, index) => (
          <tr key={element.id_tipo_recurso + index}>
            <td>
              <span title={element.tipo_recurso}>{element.tipo_recurso}</span>
            </td>
            <td>
              <span title={element.nombre_recurso}>
                {element.nombre_recurso}
              </span>
            </td>
            <td>
              <span title={element.tematica}>{element.tematica}</span>
            </td>
            <td>
              <span title={element.tipo_recurso}>
                {element.activo ? "Sí" : "No"}
              </span>
            </td>
            <td>
              <span title={element.tipo_calificacion}>
                {element.tipo_calificacion}
              </span>
            </td>
            <td>
              <span title={element.fecha_formato}>{element.fecha_formato}</span>
            </td>
            <td>
              <span title={element.nombre}>{element.nombre}</span>
            </td>
            <td>
              <span title={element.correo}>{element.correo}</span>
            </td>
            <td>
              <span title={element.nombre_uso}>{element.nombre_uso}</span>
            </td>
            <td>
              <span title={element.descripcion}>{element.descripcion}</span>
            </td>
          </tr>
        ))}
      </tbody>
    );
  } else {
    return (
      <tbody>
        <tr>
          <td colSpan={12}>Sin resultados para mostrar.</td>
        </tr>
      </tbody>
    );
  }
};
